<template>
  <el-dialog
    title="添加生日祝福"
    :visible.sync="dialogVisible"
    width="500px"
    top="30vh"
    @close="onCancel"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="50px"
      label-position="right"
      size="medium"
      style="padding: 20px 20px 0;"
    >
      <el-form-item label="礼物" prop="gift" :rules="[{ required: true, message: '请输入礼物', trigger: 'blur' }]">
        <el-input v-model="form.gift" type="textarea" :autosize="{ minRows: 5, maxRows: 5}" placeholder="请输入礼物" clearable></el-input>
      </el-form-item>
      <el-form-item label="生日密送" prop="birthday_bcc">
        <div class="tag-input-wrap">
          <el-tag v-for="(item, idx) in form.birthday_bcc"
                  :key="'bcc-' + idx"
                  closable
                  size="small"
                  @close="removeBcc(idx)">
            {{ item }}
          </el-tag>
          <el-input v-model="inputBirthdayBcc"
                    placeholder="输入后回车或逗号添加"
                    size="small"
                    class="tag-input-inner"
                    @keydown.enter.native.prevent="addBccFromInput"
                    @keydown.native.188="addBccFromInput">
          </el-input>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" :loading="loading" @click="onConfirm">确定</el-button>
      <el-button @click="onCancel">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BirthdayGiftDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      form: {
        gift: '',
        birthday_bcc: [],
      },
      inputBirthdayBcc: '',
      rules: {
        gift: [
          { required: true, message: '请输入生日礼物', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (!val || !this.row) return
        const bcc = this.row.birthday_bcc
        if (Array.isArray(bcc) && bcc.length > 0) {
          this.form.birthday_bcc = [...bcc]
          return
        }
        if (this.row.id) {
          request.page('getEmployeeDetail', this.row.id).then(({ data }) => {
            const detailBcc = data && data.birthday_bcc
            this.form.birthday_bcc = Array.isArray(detailBcc) ? [...detailBcc] : (detailBcc ? [String(detailBcc).trim()].filter(Boolean) : [])
          }).catch(() => {})
        } else {
          this.form.birthday_bcc = []
        }
      },
    },
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      },
    },
  },
  methods: {
    onCancel () {
      this.dialogVisible = false
      this.resetForm()
      this.$emit('cancel')
    },
    onConfirm () {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.$emit('confirm', {
          gift: this.form.gift,
          birthday_bcc: this.form.birthday_bcc || [],
        })
      })
    },
    removeBcc (index) {
      this.form.birthday_bcc.splice(index, 1)
    },
    addBccFromInput () {
      const raw = (this.inputBirthdayBcc || '').trim()
      if (!raw) return
      const items = raw.split(',').map(s => s.trim()).filter(Boolean)
      items.forEach(item => {
        if (item && !this.form.birthday_bcc.includes(item)) {
          this.form.birthday_bcc.push(item)
        }
      })
      this.inputBirthdayBcc = ''
    },
    resetForm () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      } else {
        this.form.gift = ''
      }
      this.form.birthday_bcc = []
      this.inputBirthdayBcc = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.tag-input-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  min-height: 36px;
  width: 100%;
}
.tag-input-wrap .tag-input-inner {
  flex: 1;
  min-width: 120px;
}
.tag-input-wrap .el-tag {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/hr/component/BirthdayGiftDialog.vue